
export default function getResource(label, vars = []) {
    const resources = { filterBy: 'Filter by' };
    return resources[label];
}
